/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
// import auth from '@/auth/authService';
// import firebase from 'firebase/app';
// import 'firebase/auth';

import VueRouterMiddleware from "vue-route-middleware";
import AuthMiddleware from "./middleware/auth";
import LoggedMiddleware from "./middleware/logged";

Vue.use(Router);

// function for push router programaticly with new tab
Router.prototype.openNewTab = function (routeObject) {
  const {
    href
  } = this.resolve(routeObject);
  window.open(href, "_blank");
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      path: "/login",
      name: "login",
      component: () => import("./views/login/Login.vue"),
      meta: {
        rule: "editor",
        middleware: [LoggedMiddleware]
      }
    },

    {
      path: "/show-document/:id",
      name: "show-document",
      component: () => import("./views/showDocument.vue"),
      meta: {
        rule: "editor"
      }
    },

    {
      path: "/document/:id",
      name: "document",
      component: () => import("./views/Document.vue"),
      meta: {
        rule: "editor"
      }
    },

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      meta: {
        middleware: [AuthMiddleware]
      },
      children: [
        // =============================================================================
        // Dashboard
        // =============================================================================
        {
          path: "/",
          redirect: "/dashboard/"
        },
        {
          path: "/dashboard/",
          name: "dashboard",
          component: () => import("./views/dashboard/Dashboard.vue"),
          meta: {
            rule: "editor",
            activeMenu: "/dashboard"
          }
        },

        // =============================================================================
        // Old Surat Route
        // =============================================================================
        {
          path: "/surat/",
          name: 'surat',
          component: () => import("./views/surat/Surat.vue"),
          meta: {
            rule: "editor",
            activeMenu: "/surat"
          },
          children: [
            // Buat Surat
            {
              path: "/surat/buat",
              name: "buat-surat",
              component: () => import("./views/surat/components/create/Create.vue"),
              meta: {
                rule: 'editor',
                activeMenu: '/surat'
              },
              children: [{
                path: "/surat/buat/masuk",
                name: "buat-surat-masuk",
                component: () => import("./views/surat/components/create/CreateInbox.vue"),
                meta: {
                  rule: 'editor',
                  activeMenu: '/surat'
                },
              }, {
                path: "/surat/buat/keluar",
                name: "buat-surat-keluar",
                component: () => import("./views/surat/components/create/CreateOutbox.vue"),
                meta: {
                  rule: 'editor',
                  activeMenu: '/surat'
                },
              }]
            },
            // Edit Surat
            {
              path: "/surat/ubah",
              name: "ubah-surat",
              component: () => import("./views/surat/components/edit/Edit.vue"),
              meta: {
                rule: 'editor',
                activeMenu: '/surat'
              },
              children: [{
                path: "/surat/ubah/masuk/:uuid",
                name: "ubah-surat-masuk",
                component: () => import("./views/surat/components/edit/EditInbox.vue"),
                meta: {
                  rule: 'editor',
                  activeMenu: '/surat'
                },
              }, {
                path: "/surat/ubah/keluar/:uuid",
                name: "ubah-surat-keluar",
                component: () => import("./views/surat/components/edit/EditOutbox.vue"),
                meta: {
                  rule: 'editor',
                  activeMenu: '/surat'
                },
              }]
            },
            // Filter Surat
            {
              path: "/surat/:filter",
              name: "surat-list",
              component: () => import("./views/surat/SuratList.vue"),
              meta: {
                rule: 'editor',
                activeMenu: '/surat'
              }
            },
            // Lihat Surat
            {
              path: "/surat/lihat/:uuid",
              name: "surat-lihat",
              component: () => import("./views/surat/SuratDetail.vue"),
              meta: {
                rule: "editor",
                activeMenu: '/surat'
              }
            },
          ]
        },

        // =============================================================================
        // Surat Masuk
        // =============================================================================
        {
          path: "/surat-masuk",
          name: 'surat-masuk',
          component: () => import("./views/surat-masuk/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-masuk'
          },
        },
        {
          path: "/surat-masuk/buat",
          name: 'surat-masuk-buat',
          component: () => import("./views/surat-masuk/Create.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-masuk'
          },
        },
        {
          path: "/surat-masuk/:uuid/detail",
          name: 'surat-masuk-detail',
          component: () => import("./views/surat-masuk/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-masuk'
          },
        },
        {
          path: "/surat-masuk/:uuid/ubah",
          name: 'surat-masuk-ubah',
          component: () => import("./views/surat-masuk/Edit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-masuk'
          },
        },

        // =============================================================================
        // Surat Keluar
        // =============================================================================
        {
          path: "/surat-keluar",
          name: 'surat-keluar',
          component: () => import("./views/surat-keluar/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-keluar'
          },
        },
        {
          path: "/surat-keluar/buat",
          name: 'surat-keluar-buat',
          component: () => import("./views/surat-keluar/Create.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-keluar'
          },
        },
        {
          path: "/surat-keluar/:uuid/detail",
          name: 'surat-keluar-detail',
          component: () => import("./views/surat-keluar/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-keluar'
          },
        },
        {
          path: "/surat-keluar/:uuid/ubah",
          name: 'surat-keluar-ubah',
          component: () => import("./views/surat-keluar/Edit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/surat-keluar'
          },
        },

        // =============================================================================
        // Agenda
        // =============================================================================
        {
          path: "/agenda",
          name: 'agenda',
          component: () => import("./views/agenda/Agenda.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/agenda'
          },
        },
        {
          path: "/agenda/buat",
          name: "agenda-buat",
          component: () => import("./views/agenda/components/AgendaCreate.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/agenda'
          }
        },
        {
          path: "/agenda/detail/:uuid",
          name: "agenda-detail",
          component: () => import("./views/agenda/AgendaDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/agenda'
          }
        },
        {
          path: "/agenda/edit/:uuid",
          name: "agenda-edit",
          component: () => import("./views/agenda/components/AgendaEdit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/agenda'
          }
        },

        // =============================================================================
        // Buku Kendali
        // =============================================================================
        {
          path: "/buku-kendali",
          name: "buku-kendali",
          component: () => import("./views/buku-kendali/BukuKendali.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/buku-kendali'
          }
        },
        {
          path: "/buku-kendali/:id/detail-surat",
          name: "buku-kendali-detail-surat",
          component: () => import("./views/buku-kendali/DetailNoSurat.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/buku-kendali'
          }
        },
        {
          path: "/buku-kendali/:id/detail-memo",
          name: "buku-kendali-detail-memo",
          component: () => import("./views/buku-kendali/DetailNoInternalMemo.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/buku-kendali'
          }
        },
        {
          path: "/update-nomor-surat-masuk",
          name: "update-nomor-surat-masuk",
          component: () => import("./views/update-nomor-surat-masuk/BukuKendali.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/buku-kendali'
          }
        },
        // =============================================================================
        // Manajemen User
        // =============================================================================
        {
          path: "/manajemen-user/create",
          name: "manajemen-user-create",
          component: () => import("./views/manajemen-user/Create.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-user'
          }
        },
        {
          path: "/manajemen-user",
          name: "manajemen-user",
          component: () => import("./views/manajemen-user/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-user'
          }
        },
        {
          path: "/manajemen-user/detail/:uuid",
          name: "manajemen-user-detail",
          component: () => import("./views/manajemen-user/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-user'
          },
        },
        {
          path: "/manajemen-user/edit/:uuid",
          name: "manajemen-user-edit",
          component: () => import("./views/manajemen-user/Edit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-user'
          },
        },
        {
          path: "/manajemen-user/edit-credentials/:uuid",
          name: "manajemen-user-edit-credentials",
          component: () => import("./views/manajemen-user/EditCredentials.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-user'
          },
        },

        // =============================================================================
        // Absensi
        // =============================================================================
        {
          path: "/absensi",
          name: "absensi",
          component: () => import("./views/absensi/Absensi.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/absensi'
          },
        },
        {
          path: "/absensi/detail/:uuid",
          name: "absensi-detail",
          component: () => import("./views/absensi/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/absensi'
          }
        },
        {
          path: "/laporan-absensi",
          name: "laporan-absensi",
          component: () => import("./views/laporan-absensi/LaporanAbsensi.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/laporan-absensi'
          },
        },
        {
          path: "/laporan-absensi/pegawai/:uuid",
          name: "laporan-absensi-pegawai",
          component: () => import("./views/laporan-absensi/LaporanAbsensiPegawai.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/laporan-absensi'
          },
        },
        {
          path: "/laporan-absensi/pegawai/:uuid/detail/:uuidAbsensi",
          name: "laporan-absensi-pegawai-detail",
          component: () => import("./views/laporan-absensi/LaporanAbsensiPegawaiDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/laporan-absensi'
          },
        },

        // =============================================================================
        // Template Surat
        // =============================================================================
        {
          path: "/template-surat",
          name: "template-surat",
          component: () => import("./views/template-surat/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/template-surat'
          }
        },
        {
          path: "/template-surat/detail/:uuid",
          name: "template-surat-detail",
          component: () => import("./views/template-surat/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/template-surat'
          }
        },

        // =============================================================================
        // Profile
        // =============================================================================
        {
          path: "/profile",
          name: "profile",
          component: () => import("./views/profile/Profile.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/profile'
          }
        },
        {

          path: '/profile/bidang/:id',
          name: 'profile-bidang',
          component: () => import('./views/profile/Bidang.vue'),
          meta: {
            rule: 'editor',
            activeMenu: '/profile'
          },
        },
        {
          path: '/arsip',
          redirect: '/surat/masuk',
        },

        // =============================================================================
        // Notifikasi
        // =============================================================================
        {
          path: "/notifikasi",
          name: "notifikasi",
          component: () => import("./views/notifikasi/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/notifikasi'
          }
        },

        // =============================================================================
        // Hak Akses
        // =============================================================================
        {
          path: "/hak-akses",
          name: "hak-akses",
          component: () => import("./views/hak-akses/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/hak-akses'
          }
        },
        {
          path: "/hak-akses/create",
          name: "hak-akses-create",
          component: () => import("./views/hak-akses/Create.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/hak-akses'
          }
        },
        {
          path: "/hak-akses/detail/:uuid",
          name: "hak-akses-detail",
          component: () => import("./views/hak-akses/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/hak-akses'
          }
        },
        {
          path: "/kategori-agenda",
          name: "kategori-agenda",
          component: () => import("./views/kategori-agenda/KategoriAgenda.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/kategori-agenda'
          }
        },
        {
          path: "/bidang",
          name: "bidang",
          component: () => import("./views/bidang/Bidang.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/bidang'
          }
        },
        {
          path: "/bidang/:uuid/detail",
          name: "bidang-detail",
          component: () => import("./views/bidang/BidangDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/bidang'
          }
        },
        {
          path: "/jabatan",
          name: "jabatan",
          component: () => import("./views/jabatan/Jabatan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/jabatan'
          }
        },
        {
          path: "/jabatan/:uuid/detail",
          name: "jabatan-detail",
          component: () => import("./views/jabatan/JabatanDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/jabatan'
          }
        },
        {
          path: "/manajemen-notifikasi",
          name: "manajemen-notifikasi",
          component: () => import("./views/manajemen-notifikasi/Notifikasi.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-notifikasi'
          }
        },
        {
          path: "/manajemen-notifikasi/:uuid/detail",
          name: "manajemen-notifikasi-detail",
          component: () => import("./views/manajemen-notifikasi/NotifikasiDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-notifikasi'
          }
        },

        // =============================================================================
        // JAMKRIDA ASET
        // =============================================================================
        {
          path: "/aset",
          name: "aset",
          component: () => import("./views/aset/Aset.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/aset'
          }
        },
        {
          path: "/aset/detail/:uuid",
          name: "aset-detail",
          component: () => import("./views/aset/AsetDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/aset'
          }
        },

        // =============================================================================
        // NILAI PENJAMINAN
        // =============================================================================
        {
          path: "/nilai-penjaminan",
          name: "nilai-penjaminan",
          component: () => import("./views/nilai-penjaminan/NilaiPenjaminan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/NilaiPenjaminan'
          }
        },
        {
          path: "/nilai-penjaminan/detail/:uuid",
          name: "nilai-penjaminan-detail",
          component: () => import("./views/nilai-penjaminan/NilaiPenjaminanDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/nilai-penjaminan'
          }
        },

        // =============================================================================
        // PLAFOND PENJAMINAN
        // =============================================================================
        {
          path: "/plafond-penjaminan",
          name: "plafond-penjaminan",
          component: () => import("./views/plafond-penjaminan/PlafondPenjaminan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/plafond-penjaminan'
          }
        },
        {
          path: "/plafond-penjaminan/detail/:uuid",
          name: "plafond-penjaminan-detail",
          component: () => import("./views/plafond-penjaminan/PlafondPenjaminanDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/plafond-penjaminan'
          }
        },

        // =============================================================================
        // IMBAL JASA PENJAMINAN
        // =============================================================================
        {
          path: "/imbal-jasa-penjaminan",
          name: "imbal-jasa-penjaminan",
          component: () => import("./views/imbal-jasa-penjaminan/ImbalJasaPenjaminan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/imbal-jasa-penjaminan'
          }
        },
        {
          path: "/imbal-jasa-penjaminan/detail/:uuid",
          name: "imbal-jasa-penjaminan-detail",
          component: () => import("./views/imbal-jasa-penjaminan/ImbalJasaPenjaminanDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/imbal-jasa-penjaminan'
          }
        },

        // =============================================================================
        // TERJAMIN
        // =============================================================================
        {
          path: "/terjamin",
          name: "terjamin",
          component: () => import("./views/terjamin/Terjamin.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/terjamin'
          }
        },
        {
          path: "/terjamin/detail/:uuid",
          name: "terjamin-detail",
          component: () => import("./views/terjamin/TerjaminDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/terjamin'
          }
        },

        // =============================================================================
        // PEMEGANG SAHAM
        // =============================================================================
        {
          path: "/pemegang-saham",
          name: "pemegang-saham",
          component: () => import("./views/pemegang-saham/PemegangSaham.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/pemegang-saham'
          }
        },
        {
          path: "/pemegang-saham/detail/:uuid",
          name: "pemegang-saham-detail",
          component: () => import("./views/pemegang-saham/PemegangSahamDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/pemegang-saham'
          }
        },

        // =============================================================================
        // NON PERFORMING GUARANTEE
        // =============================================================================
        {
          path: "/non-performing-guarantee",
          name: "non-performing-guarantee",
          component: () => import("./views/non-performing-guarantee/NonPerformingGuarantee.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/non-performing-guarantee'
          }
        },
        {
          path: "/non-performing-guarantee/detail/:uuid",
          name: "non-performing-guarantee-detail",
          component: () => import("./views/non-performing-guarantee/NonPerformingGuaranteeDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/non-performing-guarantee'
          }
        },

        // =============================================================================
        // EKUITAS
        // =============================================================================
        {
          path: "/ekuitas",
          name: "ekuitas",
          component: () => import("./views/ekuitas/Ekuitas.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/ekuitas'
          }
        },
        {
          path: "/ekuitas/detail/:uuid",
          name: "ekuitas-detail",
          component: () => import("./views/ekuitas/EkuitasDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/ekuitas'
          }
        },

        // =============================================================================
        // TARGET PERUSAHAAN
        // =============================================================================
        {
          path: "/target-perusahaan",
          name: "target-perusahaan",
          component: () => import("./views/target-perusahaan/TargetPerusahaan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/target-perusahaan'
          }
        },
        {
          path: "/target-perusahaan/detail/:uuid",
          name: "target-perusahaan-detail",
          component: () => import("./views/target-perusahaan/TargetPerusahaanDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/target-perusahaan'
          }
        },

        // =============================================================================
        // LABA
        // =============================================================================
        {
          path: "/laba",
          name: "laba",
          component: () => import("./views/laba/Laba.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/laba'
          }
        },
        {
          path: "/laba/detail/:uuid",
          name: "laba-detail",
          component: () => import("./views/laba/LabaDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/laba'
          }
        },

        // =============================================================================
        // REKANAN
        // =============================================================================
        {
          path: "/rekanan",
          name: "rekanan",
          component: () => import("./views/rekanan/Rekanan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/rekanan'
          }
        },
        {
          path: "/rekanan/detail/:uuid",
          name: "rekanan-detail",
          component: () => import("./views/rekanan/RekananDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/rekanan'
          }
        },

        // =============================================================================
        // INTERNAL MEMO
        // =============================================================================
        {
          path: "/internal-memo",
          name: "internal-memo",
          component: () => import("./views/internal-memo/InternalMemo.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/internal-memo'
          }
        },
        {
          path: "/internal-memo/buat",
          name: "internal-memo-buat",
          component: () => import("./views/internal-memo/InternalMemoCreate.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/internal-memo'
          }
        },
        {
          path: "/internal-memo/detail/:uuid",
          name: "internal-memo-detail",
          component: () => import("./views/internal-memo/InternalMemoDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/internal-memo'
          }
        },
        {
          path: "/internal-memo/edit/:uuid",
          name: "internal-memo-edit",
          component: () => import("./views/internal-memo/InternalMemoEdit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/internal-memo'
          }
        },

        // =============================================================================
        // INTERNAL MEMO
        // =============================================================================
        {
          path: "/notulen",
          name: "notulen",
          component: () => import("./views/notulen/Notulen.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/notulen'
          }
        },
        {
          path: "/notulen/buat",
          name: "notulen-buat",
          component: () => import("./views/notulen/NotulenCreate.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/notulen'
          }
        },
        {
          path: "/notulen/detail/:uuid",
          name: "notulen-detail",
          component: () => import("./views/notulen/NotulenDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/notulen'
          }
        },
        {
          path: "/notulen/edit/:uuid",
          name: "notulen-edit",
          component: () => import("./views/notulen/NotulenEdit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/notulen'
          }
        },

        // =============================================================================
        // MANAJEMEN KOMITE
        // =============================================================================
        {
          path: "/komite",
          name: "komite",
          component: () => import("./views/komite/Komite.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/komite'
          }
        },
        {
          path: "/komite/:uuid/detail",
          name: "komite-detail",
          component: () => import("./views/komite/KomiteDetail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/komite'
          }
        },
        {
          path: "/perkembangan-perusahaan",
          name: "perkembangan-perusahaan",
          component: () => import("./views/perkembangan-perusahaan/PerkembanganPerusahaan.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/perkembangan-perusahaan'
          }
        },

        // =============================================================================
        // MANAJEMEN SK DIREKSI
        // =============================================================================
        {
          path: "/manajemen-sk-direksi",
          name: "manajemen-sk-direksi",
          component: () => import("./views/manajemen-sk-direksi/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-sk-direksi'
          }
        },
        {
          path: "/manajemen-sk-direksi/create",
          name: "manajemen-sk-direksi-create",
          component: () => import("./views/manajemen-sk-direksi/Create.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-sk-direksi'
          }
        },
        {
          path: "/manajemen-sk-direksi/:uuid/detail",
          name: "manajemen-sk-direksi-detail",
          component: () => import("./views/manajemen-sk-direksi/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-sk-direksi'
          }
        },
        {
          path: "/manajemen-sk-direksi/:uuid/edit",
          name: "manajemen-sk-direksi-edit",
          component: () => import("./views/manajemen-sk-direksi/Edit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-sk-direksi'
          }
        },

        // =============================================================================
        // MANAJEMEN PERATURAN
        // =============================================================================
        {
          path: "/manajemen-peraturan",
          name: "manajemen-peraturan",
          component: () => import("./views/manajemen-peraturan/Index.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-peraturan'
          }
        },
        {
          path: "/manajemen-peraturan/create",
          name: "manajemen-peraturan-create",
          component: () => import("./views/manajemen-peraturan/Create.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-peraturan'
          }
        },
        {
          path: "/manajemen-peraturan/:uuid/detail",
          name: "manajemen-peraturan-detail",
          component: () => import("./views/manajemen-peraturan/Detail.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-peraturan'
          }
        },
        {
          path: "/manajemen-peraturan/:uuid/edit",
          name: "manajemen-peraturan-edit",
          component: () => import("./views/manajemen-peraturan/Edit.vue"),
          meta: {
            rule: "editor",
            activeMenu: '/manajemen-peraturan'
          }
        }
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

// router.beforeEach((to, from, next) => {
//   firebase.auth().onAuthStateChanged(() => {
//     // get firebase current user
//     const firebaseCurrentUser = firebase.auth().currentUser;

//     // if (
//     //     to.path === "/pages/login" ||
//     //     to.path === "/pages/forgot-password" ||
//     //     to.path === "/pages/error-404" ||
//     //     to.path === "/pages/error-500" ||
//     //     to.path === "/pages/register" ||
//     //     to.path === "/callback" ||
//     //     to.path === "/pages/comingsoon" ||
//     //     (auth.isAuthenticated() || firebaseCurrentUser)
//     // ) {
//     //     return next();
//     // }

//     // If auth required, check login. If login fails redirect to login page
//     if (to.meta.authRequired) {
//       if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
//         router.push({ path: '/pages/login', query: { to: to.path } });
//       }
//     }

//     return next();
//     // Specify the current path as the customState parameter, meaning it
//     // will be returned to the application after auth
//     // auth.login({ target: to.path });
//   });
// });

router.beforeEach(
  VueRouterMiddleware({
    AuthMiddleware,
    LoggedMiddleware
  })
);

export default router;
